import { Collapse, Descriptions, Typography } from "antd";
import Colors from "infrastructure/utils/colors";
import { NotificationDetailRow } from "../utils/formatNotificationPresentation";

const { Panel } = Collapse;
const { Text } = Typography;

const EMPTY_VALUE = "—";

type NotificationDetailsCollapseProps = {
  panelKey: string;
  isRtl: boolean;
  headerLabel: string;
  rows: NotificationDetailRow[];
};

const NotificationDetailsCollapse = ({
  panelKey,
  isRtl,
  headerLabel,
  rows,
}: NotificationDetailsCollapseProps) => (
  <Collapse
    bordered={false}
    expandIconPosition={isRtl ? "start" : "end"}
    style={{
      background: Colors.black_4,
      borderRadius: 10,
      marginTop: 10,
    }}
  >
    <Panel
      header={
        <Text strong style={{ fontSize: 13 }}>
          {headerLabel}
        </Text>
      }
      key={panelKey}
    >
      <Descriptions
        column={1}
        size="small"
        colon={false}
        labelStyle={{
          color: Colors.mint_gray,
          width: isRtl ? undefined : 140,
          paddingBottom: 6,
        }}
        contentStyle={{ color: Colors.charcoal_grey, paddingBottom: 6 }}
      >
        {rows.map((row) => (
          <Descriptions.Item key={row.label} label={row.label}>
            {row.value || EMPTY_VALUE}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </Panel>
  </Collapse>
);

export default NotificationDetailsCollapse;
